let initialState = {

}

let loginReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return {...state}
  }
}

export default loginReducer